export default "__VITE_ASSET__2c4cc094__"